// ============================================
// GASTOS.JS — Mobile-first expense management
// ============================================
import React, { useState, useEffect, useRef } from 'react';
import { OPC_DINERO } from './utils/dinero';

const PP = "'Poppins', sans-serif";
const KEY = 'beep_gastos';
const C = { azul: '#5c9adb', osc: '#2f5f9e', verde: '#5cd4b0', rojo: '#e05c5c', amarillo: '#dcde74', fondo: '#f3f4f4', card: '#fff', gris: '#6B7280', borde: '#e8eaed' };

const TIPOS = [
  { id: 'combustible', l: 'Combustible', ic: '⛽', col: '#F59E0B' },
  { id: 'material', l: 'Material', ic: '🔧', col: '#3B82F6' },
  { id: 'herramienta', l: 'Herramienta', ic: '🪛', col: '#6366F1' },
  { id: 'comida', l: 'Comida', ic: '🍽️', col: '#EF4444' },
  { id: 'transporte', l: 'Transporte', ic: '🚗', col: '#10B981' },
  { id: 'otro', l: 'Otro', ic: '📄', col: '#9CA3AF' },
];

const TABS = [
  { id: 'pendientes', l: '📋 Pendientes' },
  { id: 'historial', l: '✅ Historial' },
  { id: 'graficas', l: '📊 Gráficas' },
  { id: 'personal', l: '🏠 Personal' },
];

const ESTADO_BADGE = {
  borrador: { bg: '#E5E7EB', fg: '#4B5563', t: 'Borrador' },
  pendiente: { bg: '#DBEAFE', fg: '#1E40AF', t: 'Pendiente' },
  aprobado: { bg: '#D1FAE5', fg: '#065F46', t: 'Aprobado' },
  pagado: { bg: '#DBEAFE', fg: '#1E40AF', t: 'Pagado' },
  rechazado: { bg: '#FEE2E2', fg: '#991B1B', t: 'Rechazado' },
  personal: { bg: '#EDE9FE', fg: '#5B21B6', t: 'Personal' },
};

function leer(k, d) { try { const r = localStorage.getItem(k); return r ? JSON.parse(r) : d; } catch { return d; } }
function guardar(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} }
function fmt(m) { return '$' + (m || 0).toLocaleString('es-MX', OPC_DINERO); }
function fCorta(iso) { if (!iso) return ''; return new Date(iso).toLocaleDateString('es-MX', { day: 'numeric', month: 'short' }); }

function seedGastos() {
  return [
    { id: 1, folio: 'GST-2026-001', usuario: 'Ricardo Herrera', tipo: 'combustible', categoria: 'empresa', esPersonal: false, descripcion: 'Gasolina visita cliente Bodegas Alianza', monto: 450, moneda: 'MXN', montoMXN: 450, fecha: new Date(Date.now() - 86400000).toISOString(), estado: 'pendiente', servicioRelacionado: 'SRV-2026-001', proyectoRelacionado: '', notas: '', comprobante: null, historial: [], fechaLimitePago: null, notaPago: '', tipoCambio: 17.5, aprobadoPor: null, fechaAprobacion: null },
    { id: 2, folio: 'GST-2026-002', usuario: 'Ricardo Herrera', tipo: 'material', categoria: 'empresa', esPersonal: false, descripcion: 'Cable UTP extra no contemplado en cotización', monto: 280, moneda: 'MXN', montoMXN: 280, fecha: new Date(Date.now() - 2 * 86400000).toISOString(), estado: 'aprobado', proyectoRelacionado: 'PRY-2026-100', servicioRelacionado: '', notas: '', comprobante: null, historial: [], fechaLimitePago: null, notaPago: '', tipoCambio: 17.5, aprobadoPor: 'Ricardo', fechaAprobacion: new Date().toISOString() },
    { id: 3, folio: 'GST-2026-003', usuario: 'Ricardo Herrera', tipo: 'otro', categoria: 'personal', esPersonal: true, descripcion: 'Tarjeta de crédito Santander', monto: 8500, moneda: 'MXN', montoMXN: 8500, fecha: new Date().toISOString(), fechaLimitePago: new Date(Date.now() + 3 * 86400000).toISOString(), notaPago: 'Pagar antes del 15 para no pagar intereses', estado: 'personal', servicioRelacionado: '', proyectoRelacionado: '', notas: '', comprobante: null, historial: [], tipoCambio: 17.5, aprobadoPor: null, fechaAprobacion: null },
    { id: 4, folio: 'GST-2026-004', usuario: 'Ricardo Herrera', tipo: 'comida', categoria: 'empresa', esPersonal: false, descripcion: 'Comida con cliente Farma Plus', monto: 1200, moneda: 'MXN', montoMXN: 1200, fecha: new Date(Date.now() - 3 * 86400000).toISOString(), estado: 'borrador', servicioRelacionado: '', proyectoRelacionado: '', notas: '', comprobante: null, historial: [], fechaLimitePago: null, notaPago: '', tipoCambio: 17.5, aprobadoPor: null, fechaAprobacion: null },
  ];
}

function cargarGastos() {
  const g = leer(KEY, null);
  if (g && g.length) return g;
  const seed = seedGastos();
  guardar(KEY, seed);
  return seed;
}

function genFolio(arr) { return `GST-2026-${String(arr.length + 1).padStart(3, '0')}`; }

function diasRestantes(fechaLimite) {
  if (!fechaLimite) return null;
  const diff = Math.ceil((new Date(fechaLimite) - new Date()) / 86400000);
  return diff;
}

function crearAprobacion(gasto, usuario) {
  const aprs = leer('beep_aprobaciones', []);
  aprs.push({
    id: Date.now(), folio: `APR-${gasto.folio}`, tipo: 'gasto', agente: 'nova',
    titulo: 'Gasto pendiente de aprobación',
    descripcion: `${usuario} solicita reembolso de ${fmt(gasto.montoMXN)} por ${gasto.descripcion}`,
    monto: gasto.montoMXN, gastoId: gasto.id, solicitadoPor: usuario,
    estado: 'pendiente', prioridad: 'normal',
    datos: { gastoId: gasto.id, folio: gasto.folio },
    fechaCreacion: new Date().toISOString(), fechaRespuesta: null, respondidoPor: null, notaRechazo: '',
  });
  guardar('beep_aprobaciones', aprs);
  window.dispatchEvent(new Event('beep:aprobaciones-actualizadas'));
}

// ===================================================================
// COMPONENTE PRINCIPAL
// ===================================================================
export default function Gastos({ rol, nombre, onNavegar, esCelular, todos }) {
  const [gastos, setGastos] = useState(cargarGastos);
  const [tab, setTab] = useState('pendientes');
  const [editando, setEditando] = useState(null);
  const [toast, setToast] = useState(null);
  const [ancho, setAncho] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  useEffect(() => {
    const h = () => setAncho(window.innerWidth);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  useEffect(() => {
    const s = () => setGastos(cargarGastos());
    window.addEventListener('storage', s);
    window.addEventListener('beep:gastos-actualizados', s);
    return () => { window.removeEventListener('storage', s); window.removeEventListener('beep:gastos-actualizados', s); };
  }, []);
  useEffect(() => {
    const h = (e) => {
      const datos = e.detail || {};
      setEditando({ ...gastoVacio(nombre), ...datos });
    };
    window.addEventListener('beep:nuevo-gasto', h);
    return () => window.removeEventListener('beep:nuevo-gasto', h);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const movil = esCelular || ancho < 768;
  const usr = (nombre || 'Ricardo').split(' ')[0];

  const guardarAll = (arr) => {
    setGastos(arr);
    guardar(KEY, arr);
    window.dispatchEvent(new Event('beep:gastos-actualizados'));
  };

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2500); };

  const onSave = (g) => {
    const exists = gastos.find(x => x.id === g.id);
    const arr = exists ? gastos.map(x => x.id === g.id ? g : x) : [...gastos, g];
    guardarAll(arr);
    setEditando(null);
  };

  const onDelete = (id) => { guardarAll(gastos.filter(g => g.id !== id)); };

  const onEnviar = (g) => {
    const updated = { ...g, estado: 'pendiente', historial: [...(g.historial || []), { accion: 'Enviado a aprobación', fecha: new Date().toISOString(), usuario: usr }] };
    onSave(updated);
    crearAprobacion(updated, usr);
    showToast('✅ Enviado a Nova para aprobación');
  };

  const pendientes = gastos.filter(g => !g.esPersonal && ['borrador', 'pendiente', 'rechazado'].includes(g.estado));
  const historial = gastos.filter(g => !g.esPersonal && ['aprobado', 'pagado'].includes(g.estado));
  const personales = gastos.filter(g => g.esPersonal);
  const totalPendiente = gastos.filter(g => g.estado === 'pendiente' && !g.esPersonal).reduce((s, g) => s + (g.montoMXN || g.monto || 0), 0);

  return (
    <div style={{ fontFamily: PP, maxWidth: '100%', boxSizing: 'border-box', position: 'relative', minHeight: '70vh' }}>
      {toast && (
        <div style={{ position: 'fixed', top: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, background: C.verde, color: '#fff', padding: '10px 20px', borderRadius: 12, fontWeight: 700, fontSize: 13, boxShadow: '0 4px 16px rgba(0,0,0,0.15)' }}>
          {toast}
        </div>
      )}

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, padding: movil ? '0' : '0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ fontSize: movil ? 20 : 24, fontWeight: 800, color: '#1a1a1a' }}>Mis gastos 💳</div>
          {totalPendiente > 0 && (
            <span style={{ background: C.verde + '22', color: C.verde, fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 999 }}>
              {fmt(totalPendiente)} pendiente
            </span>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 14, overflowX: 'auto', paddingBottom: 2 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: '8px 14px', borderRadius: 10, border: 'none', whiteSpace: 'nowrap',
            background: tab === t.id ? C.azul : '#fff',
            color: tab === t.id ? '#fff' : C.gris,
            fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: PP,
            boxShadow: tab === t.id ? `0 2px 8px ${C.azul}44` : '0 1px 3px rgba(0,0,0,0.06)',
          }}>{t.l}</button>
        ))}
      </div>

      {/* Content */}
      {tab === 'pendientes' && <TabPendientes gastos={pendientes} movil={movil} onTap={setEditando} onDelete={onDelete} />}
      {tab === 'historial' && <TabHistorial gastos={historial} movil={movil} />}
      {tab === 'graficas' && <TabGraficas gastos={gastos} movil={movil} />}
      {tab === 'personal' && <TabPersonal gastos={personales} movil={movil} onTap={setEditando} onDelete={onDelete} />}

      {/* FAB */}
      <button onClick={() => setEditando(gastoVacio(nombre))} style={{
        position: 'fixed', bottom: 90, right: 24, width: 56, height: 56,
        borderRadius: '50%', background: C.verde, color: '#fff', border: 'none',
        fontSize: 28, fontWeight: 300, cursor: 'pointer', boxShadow: '0 4px 16px rgba(92,212,176,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 900,
      }}>+</button>

      {/* Modal */}
      {editando && (
        <ModalGasto
          gasto={editando}
          onSave={onSave}
          onEnviar={onEnviar}
          onClose={() => setEditando(null)}
          onDelete={onDelete}
          movil={movil}
          nombre={usr}
          gastos={gastos}
          showToast={showToast}
        />
      )}
    </div>
  );
}

function gastoVacio(nombre) {
  return {
    id: Date.now(), folio: '', usuario: nombre || 'Ricardo', tipo: 'otro',
    categoria: 'empresa', esPersonal: false, descripcion: '', monto: 0,
    moneda: 'MXN', tipoCambio: 17.5, montoMXN: 0, comprobante: null,
    fecha: new Date().toISOString(), fechaLimitePago: null, notaPago: '',
    estado: 'borrador', aprobadoPor: null, fechaAprobacion: null,
    servicioRelacionado: '', proyectoRelacionado: '', notas: '',
    historial: [], _isNew: true,
  };
}

// ===================================================================
// TAB PENDIENTES
// ===================================================================
function TabPendientes({ gastos, movil, onTap, onDelete }) {
  if (!gastos.length) return <Empty msg="Sin gastos pendientes" />;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {gastos.map(g => <GastoCard key={g.id} g={g} movil={movil} onTap={onTap} onDelete={onDelete} />)}
    </div>
  );
}

// ===================================================================
// TAB HISTORIAL
// ===================================================================
function TabHistorial({ gastos, movil }) {
  const [filtro, setFiltro] = useState('todos');
  const filtrados = filtro === 'todos' ? gastos : gastos.filter(g => g.estado === filtro);
  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
        {['todos', 'aprobado', 'pagado'].map(f => (
          <button key={f} onClick={() => setFiltro(f)} style={{
            padding: '6px 12px', borderRadius: 999, border: `1px solid ${filtro === f ? C.azul : C.borde}`,
            background: filtro === f ? C.azul + '15' : '#fff', color: filtro === f ? C.azul : C.gris,
            fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: PP, textTransform: 'capitalize',
          }}>{f === 'todos' ? 'Todos' : f === 'aprobado' ? 'Aprobados' : 'Pagados'}</button>
        ))}
      </div>
      {!filtrados.length ? <Empty msg="Sin gastos en historial" /> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {filtrados.map(g => <GastoCardCompact key={g.id} g={g} movil={movil} />)}
        </div>
      )}
    </div>
  );
}

// ===================================================================
// TAB GRÁFICAS
// ===================================================================
function TabGraficas({ gastos, movil }) {
  const hoy = new Date();
  const mesAct = hoy.getMonth(), anoAct = hoy.getFullYear();
  const empresa = gastos.filter(g => !g.esPersonal);
  const gMes = empresa.filter(g => { const f = new Date(g.fecha); return f.getMonth() === mesAct && f.getFullYear() === anoAct; });
  const totalMes = gMes.reduce((s, g) => s + (g.montoMXN || g.monto || 0), 0);
  const totalPend = empresa.filter(g => g.estado === 'pendiente').reduce((s, g) => s + (g.montoMXN || g.monto || 0), 0);
  const totalAprob = gMes.filter(g => g.estado === 'aprobado').reduce((s, g) => s + (g.montoMXN || g.monto || 0), 0);
  const totalPers = gastos.filter(g => g.esPersonal).reduce((s, g) => s + (g.montoMXN || g.monto || 0), 0);
  const totalEmpresa = empresa.reduce((s, g) => s + (g.montoMXN || g.monto || 0), 0);

  // Per month
  const meses = [];
  for (let i = 5; i >= 0; i--) {
    const m = new Date(anoAct, mesAct - i, 1);
    const tot = empresa.filter(g => { const f = new Date(g.fecha); return f.getMonth() === m.getMonth() && f.getFullYear() === m.getFullYear(); }).reduce((s, g) => s + (g.montoMXN || g.monto || 0), 0);
    meses.push({ lb: m.toLocaleDateString('es-MX', { month: 'short' }), tot });
  }
  const maxM = Math.max(...meses.map(m => m.tot), 1);

  // Per type
  const porTipo = {};
  empresa.forEach(g => { const t = g.tipo || 'otro'; porTipo[t] = (porTipo[t] || 0) + (g.montoMXN || g.monto || 0); });
  const totalT = Object.values(porTipo).reduce((a, b) => a + b, 0) || 1;

  const card = (label, val, col) => (
    <div style={{ background: '#fff', borderRadius: 14, padding: movil ? 12 : 14, border: `1px solid ${C.borde}`, flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 10, color: C.gris, fontWeight: 600, textTransform: 'uppercase' }}>{label}</div>
      <div style={{ fontSize: movil ? 18 : 22, fontWeight: 800, color: col, marginTop: 4 }}>{fmt(val)}</div>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        {card('Este mes', totalMes, C.azul)}
        {card('Pendiente', totalPend, C.amarillo)}
        {card('Aprobado', totalAprob, C.verde)}
        {card('Personal', totalPers, '#8B5CF6')}
      </div>

      {/* Barras por mes */}
      <div style={{ background: '#fff', borderRadius: 14, padding: 16, border: `1px solid ${C.borde}` }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a', marginBottom: 14 }}>Últimos 6 meses</div>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 110 }}>
          {meses.map((m, i) => (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
              <div style={{ fontSize: 8, color: C.gris, fontWeight: 700 }}>{m.tot > 0 ? fmt(m.tot) : ''}</div>
              <div style={{ width: '100%', maxWidth: 32, height: Math.max((m.tot / maxM) * 80, 3), background: `linear-gradient(180deg, ${C.azul}, ${C.osc})`, borderRadius: 5 }} />
              <div style={{ fontSize: 9, color: C.gris, fontWeight: 700, textTransform: 'uppercase' }}>{m.lb}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Categorías */}
      <div style={{ background: '#fff', borderRadius: 14, padding: 16, border: `1px solid ${C.borde}` }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a1a', marginBottom: 12 }}>Por categoría</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {Object.entries(porTipo).sort((a, b) => b[1] - a[1]).map(([tipo, monto]) => {
            const pct = Math.round((monto / totalT) * 100);
            const info = TIPOS.find(t => t.id === tipo) || TIPOS[5];
            return (
              <div key={tipo}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: '#333' }}>{info.ic} {info.l}</span>
                  <span style={{ fontSize: 12, fontWeight: 700, color: '#333' }}>{fmt(monto)} ({pct}%)</span>
                </div>
                <div style={{ height: 8, background: C.fondo, borderRadius: 4, overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: pct + '%', background: info.col, borderRadius: 4, transition: 'width 0.4s' }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Empresa vs Personal */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <div style={{ background: '#fff', borderRadius: 14, padding: 16, border: `1px solid ${C.borde}`, textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: C.gris, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>🏢 Empresa</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: C.azul }}>{fmt(totalEmpresa)}</div>
        </div>
        <div style={{ background: '#fff', borderRadius: 14, padding: 16, border: `1px solid ${C.borde}`, textAlign: 'center' }}>
          <div style={{ fontSize: 10, color: C.gris, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>🏠 Personal</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#8B5CF6' }}>{fmt(totalPers)}</div>
        </div>
      </div>
    </div>
  );
}

// ===================================================================
// TAB PERSONAL
// ===================================================================
function TabPersonal({ gastos, movil, onTap, onDelete }) {
  if (!gastos.length) return <Empty msg="Sin gastos personales" ic="🔒" />;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {gastos.map(g => {
        const dias = diasRestantes(g.fechaLimitePago);
        const dColor = dias === null ? null : dias > 6 ? C.verde : dias > 2 ? '#D97706' : C.rojo;
        const tipo = TIPOS.find(t => t.id === g.tipo) || TIPOS[5];
        return (
          <div key={g.id} onClick={() => onTap(g)} style={{
            background: '#fafff9', borderRadius: 14, padding: movil ? 12 : 14,
            border: `1px solid #d9e8d4`, cursor: 'pointer',
            display: 'flex', gap: 12, alignItems: 'center',
          }}>
            <div style={{ width: 40, height: 40, borderRadius: 10, background: '#E8F5E9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>
              {tipo.ic}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginBottom: 2 }}>
                <span style={{ fontSize: 11, color: C.gris }}>{g.folio}</span>
                <span style={{ fontSize: 11, color: C.gris }}>{fCorta(g.fecha)}</span>
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a1a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {g.descripcion || 'Sin descripción'}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
                <span style={{ fontSize: 16, fontWeight: 800, color: '#1a1a1a' }}>{fmt(g.montoMXN || g.monto)}</span>
                {dias !== null && (
                  <span style={{ fontSize: 11, fontWeight: 700, color: dColor, display: 'flex', alignItems: 'center', gap: 4 }}>
                    ⏰ {dias <= 0 ? 'Vencido' : `${dias} día${dias === 1 ? '' : 's'} para pagar`}
                  </span>
                )}
              </div>
              {g.notaPago && (
                <div style={{ fontSize: 11, color: '#666', marginTop: 4, fontStyle: 'italic', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {g.notaPago}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ===================================================================
// TARJETAS
// ===================================================================
function GastoCard({ g, movil, onTap, onDelete }) {
  const tipo = TIPOS.find(t => t.id === g.tipo) || TIPOS[5];
  const badge = ESTADO_BADGE[g.estado] || ESTADO_BADGE.borrador;
  const [swipe, setSwipe] = useState(0);
  const touchRef = useRef(null);

  const onTS = (e) => { if (g.estado === 'borrador') touchRef.current = e.touches[0].clientX; };
  const onTM = (e) => {
    if (!touchRef.current) return;
    const dx = touchRef.current - e.touches[0].clientX;
    if (dx > 20) setSwipe(Math.min(dx, 80));
    else setSwipe(0);
  };
  const onTE = () => { if (swipe > 60) { onDelete(g.id); } setSwipe(0); touchRef.current = null; };

  return (
    <div style={{ position: 'relative', overflow: 'hidden', borderRadius: 14 }}>
      {swipe > 0 && (
        <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: swipe, background: C.rojo, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 20, borderRadius: '0 14px 14px 0' }}>
          🗑
        </div>
      )}
      <div
        onClick={() => onTap(g)}
        onTouchStart={onTS} onTouchMove={onTM} onTouchEnd={onTE}
        style={{
          background: C.card, borderRadius: 14, padding: movil ? 12 : 14,
          border: `1px solid ${C.borde}`, cursor: 'pointer',
          transform: swipe > 0 ? `translateX(-${swipe}px)` : 'none',
          transition: swipe === 0 ? 'transform 0.2s' : 'none',
        }}
      >
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10, background: tipo.col + '18',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0,
          }}>{tipo.ic}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginBottom: 2 }}>
              <span style={{ fontSize: 11, color: tipo.col, fontWeight: 700 }}>{tipo.l}</span>
              <span style={{ fontSize: 11, color: C.gris }}>{g.folio} · {fCorta(g.fecha)}</span>
            </div>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#1a1a1a', marginBottom: 6, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {g.descripcion || 'Sin descripción'}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 17, fontWeight: 800, color: '#1a1a1a' }}>
                {fmt(g.montoMXN || g.monto)}
                {g.moneda === 'USD' && <span style={{ fontSize: 11, color: C.gris, marginLeft: 4 }}>USD</span>}
              </span>
              <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 999, background: badge.bg, color: badge.fg }}>
                {badge.t}
              </span>
            </div>
            {(g.servicioRelacionado || g.proyectoRelacionado) && (
              <div style={{ fontSize: 11, color: C.gris, marginTop: 4 }}>
                {g.servicioRelacionado && `🔧 ${g.servicioRelacionado}`}
                {g.servicioRelacionado && g.proyectoRelacionado && ' · '}
                {g.proyectoRelacionado && `🏗️ ${g.proyectoRelacionado}`}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function GastoCardCompact({ g, movil }) {
  const badge = ESTADO_BADGE[g.estado] || ESTADO_BADGE.borrador;
  const tipo = TIPOS.find(t => t.id === g.tipo) || TIPOS[5];
  return (
    <div style={{
      background: C.card, borderRadius: 12, padding: movil ? 10 : 12,
      border: `1px solid ${C.borde}`, display: 'flex', alignItems: 'center', gap: 10,
    }}>
      <span style={{ fontSize: 18 }}>{tipo.ic}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{g.descripcion}</div>
        <div style={{ fontSize: 11, color: C.gris }}>{fCorta(g.fecha)}</div>
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 800 }}>{fmt(g.montoMXN || g.monto)}</div>
        <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: badge.bg, color: badge.fg }}>{badge.t}</span>
      </div>
    </div>
  );
}

function Empty({ msg, ic }) {
  return (
    <div style={{ textAlign: 'center', padding: 48, color: C.gris }}>
      <div style={{ fontSize: 36, marginBottom: 8 }}>{ic || '📭'}</div>
      <div style={{ fontSize: 14 }}>{msg}</div>
    </div>
  );
}

// ===================================================================
// MODAL GASTO
// ===================================================================
function ModalGasto({ gasto, onSave, onEnviar, onClose, onDelete, movil, nombre, gastos, showToast }) {
  const [g, setG] = useState({ ...gasto });
  const isNew = !!g._isNew;
  const editable = ['borrador', 'rechazado', 'personal'].includes(g.estado) || isNew;

  const upd = (k, v) => setG(prev => {
    const next = { ...prev, [k]: v };
    if (k === 'monto' || k === 'moneda' || k === 'tipoCambio') {
      const m = parseFloat(k === 'monto' ? v : next.monto) || 0;
      const tc = parseFloat(k === 'tipoCambio' ? v : next.tipoCambio) || 17.5;
      next.montoMXN = next.moneda === 'USD' ? m * tc : m;
    }
    if (k === 'esPersonal') {
      next.categoria = v ? 'personal' : 'empresa';
      next.estado = v ? 'personal' : (isNew ? 'borrador' : next.estado);
    }
    return next;
  });

  const montoNum = parseFloat(g.monto) || 0;
  const valid = g.descripcion && g.descripcion.trim() && montoNum > 0;

  const handleSave = () => {
    const final = { ...g };
    if (isNew) { delete final._isNew; final.folio = genFolio(gastos); final.historial = [{ accion: 'Creado', fecha: new Date().toISOString(), usuario: nombre }]; }
    if (g.esPersonal) final.estado = 'personal';
    onSave(final);
    showToast(g.esPersonal ? '✅ Gasto personal guardado' : '✅ Borrador guardado');
  };

  const handleEnviar = () => {
    const final = { ...g };
    if (isNew) { delete final._isNew; final.folio = genFolio(gastos); final.historial = [{ accion: 'Creado', fecha: new Date().toISOString(), usuario: nombre }]; }
    onEnviar(final);
  };

  const inp = { width: '100%', padding: '10px 12px', border: `1px solid ${C.borde}`, borderRadius: 10, fontSize: 14, fontFamily: PP, outline: 'none', boxSizing: 'border-box' };
  const lbl = { fontSize: 11, fontWeight: 700, color: C.gris, marginBottom: 4, display: 'block', textTransform: 'uppercase' };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 9990, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: movil ? 'flex-end' : 'center', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', width: movil ? '100%' : 440, maxHeight: movil ? '94vh' : '85vh',
        borderRadius: movil ? '20px 20px 0 0' : 16, overflowY: 'auto', fontFamily: PP,
      }}>
        {/* Drag handle */}
        {movil && <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 4px' }}><div style={{ width: 36, height: 4, borderRadius: 2, background: '#ddd' }} /></div>}

        <div style={{ padding: '16px 18px' }}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ fontSize: 17, fontWeight: 800, color: '#1a1a1a' }}>{isNew ? 'Nuevo gasto' : g.folio}</div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 22, color: C.gris, cursor: 'pointer' }}>×</button>
          </div>

          {/* Toggle empresa/personal */}
          {editable && (
            <div style={{ display: 'flex', gap: 6, marginBottom: 16, background: C.fondo, borderRadius: 12, padding: 4 }}>
              {[false, true].map(v => (
                <button key={String(v)} onClick={() => upd('esPersonal', v)} style={{
                  flex: 1, padding: '10px 12px', borderRadius: 10, border: 'none',
                  background: g.esPersonal === v ? '#fff' : 'transparent',
                  fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: PP,
                  color: g.esPersonal === v ? (v ? '#8B5CF6' : C.azul) : C.gris,
                  boxShadow: g.esPersonal === v ? '0 1px 4px rgba(0,0,0,0.08)' : 'none',
                  minHeight: 44,
                }}>
                  {v ? '🏠 Personal' : '🏢 Empresa'}
                </button>
              ))}
            </div>
          )}

          {/* Tipo */}
          {editable && !g.esPersonal && (
            <div style={{ marginBottom: 14 }}>
              <label style={lbl}>Tipo de gasto</label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
                {TIPOS.map(t => (
                  <button key={t.id} onClick={() => upd('tipo', t.id)} style={{
                    padding: '10px 4px', borderRadius: 10, border: `1.5px solid ${g.tipo === t.id ? t.col : C.borde}`,
                    background: g.tipo === t.id ? t.col + '15' : '#fff',
                    cursor: 'pointer', fontFamily: PP, textAlign: 'center', minHeight: 44,
                  }}>
                    <div style={{ fontSize: 20 }}>{t.ic}</div>
                    <div style={{ fontSize: 10, fontWeight: 600, color: g.tipo === t.id ? t.col : C.gris, marginTop: 2 }}>{t.l}</div>
                  </button>
                ))}
              </div>
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {/* Descripción */}
            <div>
              <label style={lbl}>Descripción *</label>
              <textarea
                value={g.descripcion} onChange={e => upd('descripcion', e.target.value)}
                placeholder="¿En qué fue el gasto?" rows={3} readOnly={!editable}
                style={{ ...inp, resize: 'none' }}
              />
            </div>

            {/* Monto + moneda */}
            <div>
              <label style={lbl}>Monto *</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input type="number" value={g.monto || ''} onChange={e => upd('monto', e.target.value)}
                  placeholder="0.00" readOnly={!editable}
                  style={{ ...inp, flex: 1, fontSize: 18, fontWeight: 800 }} />
                <div style={{ display: 'flex', borderRadius: 10, overflow: 'hidden', border: `1px solid ${C.borde}` }}>
                  {['MXN', 'USD'].map(m => (
                    <button key={m} onClick={() => editable && upd('moneda', m)} style={{
                      padding: '0 14px', border: 'none', background: g.moneda === m ? C.azul : '#fff',
                      color: g.moneda === m ? '#fff' : C.gris, fontSize: 13, fontWeight: 700,
                      cursor: editable ? 'pointer' : 'default', fontFamily: PP,
                    }}>{m}</button>
                  ))}
                </div>
              </div>
              {g.moneda === 'USD' && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                  <span style={{ fontSize: 11, color: C.gris }}>TC:</span>
                  <input type="number" value={g.tipoCambio} onChange={e => upd('tipoCambio', e.target.value)}
                    readOnly={!editable} style={{ ...inp, width: 70, padding: '6px 8px', fontSize: 12 }} />
                  <span style={{ fontSize: 12, color: C.osc, fontWeight: 700 }}>= {fmt(g.montoMXN)} MXN</span>
                </div>
              )}
            </div>

            {/* Fecha */}
            <div>
              <label style={lbl}>Fecha</label>
              <input type="date" value={g.fecha ? g.fecha.split('T')[0] : ''}
                onChange={e => upd('fecha', new Date(e.target.value).toISOString())}
                readOnly={!editable} style={inp} />
            </div>

            {/* Relacionado */}
            {!g.esPersonal && editable && (
              <div style={{ display: 'flex', gap: 8 }}>
                <div style={{ flex: 1 }}>
                  <label style={lbl}>Servicio</label>
                  <input value={g.servicioRelacionado || ''} onChange={e => upd('servicioRelacionado', e.target.value)}
                    placeholder="SRV-..." style={inp} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={lbl}>Proyecto</label>
                  <input value={g.proyectoRelacionado || ''} onChange={e => upd('proyectoRelacionado', e.target.value)}
                    placeholder="PRY-..." style={inp} />
                </div>
              </div>
            )}

            {/* Personal: fecha límite */}
            {g.esPersonal && editable && (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <input type="checkbox" checked={!!g.fechaLimitePago}
                    onChange={e => upd('fechaLimitePago', e.target.checked ? new Date(Date.now() + 7 * 86400000).toISOString() : null)}
                    style={{ width: 20, height: 20 }} />
                  <span style={{ fontSize: 13, color: '#333' }}>Tiene fecha límite de pago</span>
                </div>
                {g.fechaLimitePago && (
                  <>
                    <div>
                      <label style={lbl}>Fecha límite</label>
                      <input type="date" value={g.fechaLimitePago.split('T')[0]}
                        onChange={e => upd('fechaLimitePago', new Date(e.target.value).toISOString())}
                        style={inp} />
                    </div>
                    <div>
                      <label style={lbl}>Nota de pago</label>
                      <input value={g.notaPago || ''} onChange={e => upd('notaPago', e.target.value)}
                        placeholder="Ej: Pagar en OXXO ref 123456" style={inp} />
                    </div>
                  </>
                )}
              </>
            )}

            {/* Notas */}
            <div>
              <label style={lbl}>Notas</label>
              <input value={g.notas || ''} onChange={e => upd('notas', e.target.value)}
                placeholder="Opcional" readOnly={!editable} style={inp} />
            </div>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 18, paddingBottom: movil ? 16 : 0 }}>
            {editable && g.esPersonal && (
              <button onClick={handleSave} disabled={!valid} style={{
                width: '100%', padding: 14, borderRadius: 12, border: 'none', fontSize: 15,
                fontWeight: 700, fontFamily: PP, minHeight: 48, cursor: valid ? 'pointer' : 'not-allowed',
                background: valid ? '#8B5CF6' : '#ddd', color: '#fff',
              }}>🏠 Guardar gasto personal</button>
            )}
            {editable && !g.esPersonal && (
              <>
                <button onClick={handleSave} disabled={!valid} style={{
                  width: '100%', padding: 14, borderRadius: 12, border: `1.5px solid ${C.azul}`, fontSize: 14,
                  fontWeight: 700, fontFamily: PP, minHeight: 48, cursor: valid ? 'pointer' : 'not-allowed',
                  background: '#fff', color: valid ? C.azul : '#bbb',
                }}>Guardar borrador</button>
                <button onClick={handleEnviar} disabled={!valid} style={{
                  width: '100%', padding: 14, borderRadius: 12, border: 'none', fontSize: 15,
                  fontWeight: 700, fontFamily: PP, minHeight: 48, cursor: valid ? 'pointer' : 'not-allowed',
                  background: valid ? C.azul : '#ddd', color: '#fff',
                }}>{g.estado === 'rechazado' ? 'Reenviar →' : 'Enviar a aprobación →'}</button>
              </>
            )}
            {!editable && (
              <div style={{ textAlign: 'center', fontSize: 13, color: C.gris, padding: 12 }}>
                Este gasto no se puede editar ({g.estado})
              </div>
            )}
            {(g.estado === 'borrador' || g.esPersonal) && !isNew && (
              <button onClick={() => { onDelete(g.id); onClose(); }} style={{
                width: '100%', padding: 10, borderRadius: 12, border: 'none',
                background: 'transparent', color: C.rojo, fontSize: 13, fontWeight: 600,
                cursor: 'pointer', fontFamily: PP,
              }}>Eliminar gasto</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
